"use strict";

document.addEventListener('DOMContentLoaded', () => {
  const closeButtons = document.querySelectorAll('.grJs-popup-close');
  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      const parentPopup = button.closest('.gr-popup');
      if (parentPopup) {
        parentPopup.classList.remove('gr-active');
      }
    });
  });
});